<template>
    <div class="col-12 col-lg-9 mt-4 mt-lg-0">
        <div class="card">
            <div class="order-header">
                <div class="order-header__actions">
                    <router-link to="/invoices-open" class="btn btn-xs btn-secondary">Back to Invoice History</router-link>
                </div>

                <h5 class="order-header__title">Invoice: {{ inv_number }}</h5>
                <div>
                    <p class="order-header__account">Purchase Order: {{ inv_po }}</p>
                    <p class="order-header__account">Date: {{ inv_month + '/' + inv_day + '/' + inv_year}}</p>
                    <p class="order-header__account">Shipped From: Chicago</p>
                </div>

                <div class="order-header__subtitle">
                    <!-- <mark>{{header_msg}}</mark>. -->
                    <div class="account-nav__divider" role="presentation"></div>
                    <p class="order-header__subtitle"><mark>Shipped Via:</mark> {{ inv_carrier }}</p>
                    <p class="order-header__subtitle">
                        <mark>Tracking Number:</mark>
                        <a
                            href="http://www.ups.com/WebTracking/processInputRequest?loc=en_US&Requester=NES&tracknum=1Z3805280370188498&AgreeToTermsAndConditions=yes&WT.z_eCTAid=ct1_eml_Tracking__ct1_eml_qvn_eml_5shp&WT.z_edatesent=10162020"
                            target="_blank"
                        >
                            9U3805280370168527
                        </a>
                    </p>
                    <p class="order-header__subtitle"><mark>Payment Method:</mark> Mastercard ending in 7179</p>
                </div>
                <div class="order-header__actions">
                    <td>
                        <a href="cart.php" target="_blank" class="btn btn-xs btn-primary">Re-Order</a><a href="" target="_blank" class="btn btn-xs btn-primary">Print</a>
                        <a href="pdf/DMS-Qwik Order-7592.pdf" target="_blank" class="btn btn-xs btn-primary">Download PDF</a>
                    </td>
                </div>
            </div>
            <div class="card-divider"></div>
            <div class="card-table">
                <div class="table-responsive-sm">
                    <table>
                        <thead>
                            <tr>
                                <th>Item</th>
                                <th>Product</th>
                                <th>Shipped</th>
                                <th>Backordered</th>
                                <th>Price</th>
                                <th>Core</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody class="card-table__body card-table__body--merge-rows">
                            <tr v-for="(item, indx) in items" :key="indx">
                                <td>{{ item.DIITMC }} </td>
                                <td><router-link :to="'/part/' + item.DIMFGC + '/' + item.DIITMC " class="cart-table__product-name">{{ item.DIDESC }}</router-link></td>
                                <td class="center-elements-text">{{ item.DISHQW }}</td>
                                <td class="center-elements-text">{{ item.DIBOQX }}</td>
                                <td>{{ toUSD(item.DIEPRX) }}</td>
                                <td>{{ toUSD(item.DICPRX) }}</td>
                                <td>{{toUSD(item.TOLITM) }}</td>
                            </tr>
                        </tbody>
                        <tbody class="card-table__body card-table__body--merge-rows">
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <th class="justify-right--elements-text">Subtotal</th>
                                <td class="justify-right--elements-text">{{ toUSD(inv_ord_total )}}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <th class="justify-right--elements-text">Shipping</th>
                                <td class="justify-right--elements-text">{{ toUSD(0)}}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <th class="justify-right--elements-text">Tax</th>
                                <td class="justify-right--elements-text">{{ toUSD(inv_tax )}}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <th class="justify-right--elements-text">Total</th>
                                <td class="justify-right--elements-text">{{ toUSD(inv_grand_total )}}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
        <div class="row mt-3 no-gutters mx-n2">
            <div class="col-sm-6 col-12 px-2">
                <div class="card address-card address-card--featured">
                    <div class="address-card__badge tag-badge tag-badge--theme">
                        Sold to
                    </div>
                    <div class="address-card__body">
                        <div class="address-card__name">{{ soldto_name }}</div>
                        <div class="address-card__row">
                            {{ soldto_address1 }}<br />
                            {{ soldto_address2 }} <br />

                            {{ soldto_city }}, {{ soldto_state }} {{ soldto_zip }} {{ soldto_ctry }}
                        </div>
                        <div class="address-card__row" v-if="soldto_phone != ''">
                            <div class="address-card__row-title">Phone Number</div>
                            <div class="address-card__row-content">{{ format_phone_no(soldto_phone) }}</div>
                        </div>
                        <div class="address-card__row" v-if="soldto_email != ''">
                            <div class="address-card__row-title">Email Address</div>
                            <div class="address-card__row-content">{{ soldto_email }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-12 px-2 mt-sm-0 mt-3">
                <div class="card address-card address-card--featured">
                    <div class="address-card__badge tag-badge tag-badge--theme">
                        Billing Address
                    </div>
                    <div class="address-card__body">
                        <div class="address-card__name">{{ billingname }}</div>
                        <div class="address-card__row">
                            {{ billingaddress1 }}<br />
                            {{ billingaddress2 }}<br />
                            {{ billingcity }}, {{ billingstate }} {{ billingzip }} {{ billingctry }}
                        </div>
                        <div class="address-card__row" v-if="billingphone != ''">
                            <div class="address-card__row-title">Phone Number</div>
                            <div class="address-card__row-content">{{ format_phone_no(billingphone) }}</div>
                        </div>
                        <div class="address-card__row" v-if="billingemail != ''">
                            <div class="address-card__row-title">Email Address</div>
                            <div class="address-card__row-content">{{ billingemail }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";
import Price from "../../../mixins/price";
import Formatter from "../../../mixins/formatter";

export default {
    name: "InvoiceDetails",
    mixins: [ Price, Formatter ],
    data() {
        return {
            billingname: '',
            billingaddress1: '',
            billingaddress2: '',
            billingcity: '',
            billingstate: '',
            billingzip: '',
            billingphone: '',
            billingemail: '',

            soldto_name: '',
            soldto_address1: '',
            soldto_ddress2: '',
            soldto_city: '',
            soldto_state: '',
            soldto_zip: '',
            soldto_phone: '',
            soldto_email: '',

            inv_number: '',
            inv_shipto: '',
            inv_po: '',
            inv_year: '',
            inv_month: '',
            inv_day: '',

            inv_ord_total: 0,
            inv_tax: 0,
            inv_grand_total: 0,

            items : [],

            header_msg: '',
        }
    },
    methods: {
        getInvoiceInfo() {
            this.isloading = true;

            axiosvl.post(this.$store.getters['api/invoice_details_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                        // "EHCUST": {"value": "DMS"},
                        "RMLOC": {"value": this.$route.params.rmloc},
                        "RMREFN": {"value": this.$route.params.rmrefn},
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;
                const lists = response.data.webroutine.lists;
                console.log(fields);

                const OSDET = lists.OSDET;
                const EMLIST = lists.EMLIST;

                this.items = OSDET.entries;

                for(const i in EMLIST.entries){
                    const obj = EMLIST.entries[i];
                    this.header_msg += obj.ELTEXT;
                }

                // console.log(this.header_msg);
                // let messages = [];

                this.isloading = false;
                
                const st_billing = this.$store.getters['cart/billingdetails'];

                // this.servermessages = messages;

                this.billingname = fields.ADNAME.value;
                this.billingaddress1 = fields.ADADD1.value;
                this.billingaddress2 = fields.ADADD2.value;
                this.billingcity = fields.ADCITY.value;
                this.billingstate = fields.ADSTTC.value;
                this.billingcntry = fields.ADCTRC.value;
                this.billingphone = st_billing.billingphone;
                this.billingemail = this.$store.getters['cart/email'];

                this.soldto_name = fields.WDNAME.value;
                this.soldto_address1 = fields.WDADD1.value;
                this.soldto_address2 = fields.WDADD2.value;
                this.soldto_city = fields.WDCITY.value;
                this.soldto_state = fields.WDSTTC.value;
                this.soldto_ctry = fields.WDCTRC.value;
                this.soldto_zip = fields.ADZIPC.value;
                this.soldto_email = fields.ECEMAL.value;
                this.soldto_phone = fields.ADPHON.value;

                this.inv_number = fields.HIINV.value;
                this.inv_carrier = fields.HACARR.value;
                this.inv_po = fields.HACPO.value;
                this.inv_year = fields.HIIVSY.value;
                this.inv_month = fields.HIIVSM.value;
                this.inv_day = fields.HIIVSD.value;

                this.inv_ord_total  = fields.HIIORT.value;
                this.inv_tax  = fields.HIITXT.value;
                this.inv_grand_total  = fields.HIITOT.value;


            })
            .catch((error) => {
                this.isloading = false;
                console.log("error - " + error);
            });
        },

        getOrderHistory() {
            this.isloading = true;

            const order_details_uri = this.$store.getters['api/order_details_uri'];

            axiosvl.post(order_details_uri, {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer},
                        "XRORD#": {"value": this.$route.params.rmrefn}
                    }
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;
                // const lists = response.data.webroutine.lists;
                console.log(fields);
            });
        }
    },
    created() {
        this.getInvoiceInfo();
        this.getOrderHistory();
    }

}
</script>